import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SimulationDemographyForm from './SimulationDemographyForm.jsx';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import { compose } from 'ramda';
import useGetSimulationDemographyQuery from './hooks/useGetSimulationDemographyQuery.js';
import { Loading } from '@fasstech/middle-design-system';

const SimulationDemography = ({
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  middleFeatures,
  regimeObligatoire,
  coverageZones
}) => {
  const { getSimulationDemography, loading: isFetchingGetDemography } =
    useGetSimulationDemographyQuery();

  if (isFetchingGetDemography) return <Loading />;

  return (
    <SimulationDemographyForm
      getDemography={getSimulationDemography}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      getMiddleNumber={getMiddleNumber}
      middleFeatures={middleFeatures}
      regimeObligatoire={regimeObligatoire}
      coverageZones={coverageZones}
    />
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SimulationDemography);
